<template>
  <div class="box2">
    <pageTitle
      title="核心优势" 
    />
 
    <div class="subject-box">
      <div class="item" v-for="(item, index) in items" :key="index">
        <img :src="item.image" />
        <h3>{{ item.title }}</h3>
        <p>{{ item.description1 }}</p>
        <p>{{ item.description2 }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";

export default {
  components: {
    pageTitle,
  },
  data() {
    return {
      items: [
        {
          image: require('../../../assets/coursePage/hawai/box2/icon1.png'),
          title: '免考申请制入学',
          description1: '无需参加联考或者研',
          description2: '究生考试'
        },
        {
          image: require('../../../assets/coursePage/hawai/box2/icon2.png'),
          title: '超高性价比',
          description1: '学费仅为传统留学',
          description2: '的五分之一'
        },
        {
          image: require('../../../assets/coursePage/hawai/box2/icon3.png'),
          title: '在职学习 时间灵活',
          description1: '线上学习，契合职场人',
          description2: '的生活节奏'
        },
        {
          image: require('../../../assets/coursePage/hawai/box2/icon4.png'),
          title: '卓越教学品质',
          description1: '学习期内，享美本土同',
          description2: '等资源权益'
        },
        {
          image: require('../../../assets/coursePage/hawai/box2/icon5.png'),
          title: '中文就读 自配速学',
          description1: '项目全中文可读，学习',
          description2: '时间弹性'
        },
        {
          image: require('../../../assets/coursePage/hawai/box2/icon6.png'),
          title: '证书全球认可',
          description1: '与线下留学完全相同的',
          description2: '硕士学位证书'
        },
      ]
    };
  },
};
</script>

<style lang="less" scoped>
.box2 {
  padding: 80px 0 58px;
  width: 100%;
  background: #FFFFFF;
  /deep/.course-title-box .course-title {
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 44px;
    color: #092A52;
    line-height: 64px;
    text-align: center;
  }
  .subject-box {
    padding: 48px 40px 0;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    .item {
      margin-bottom: 22px;
      width: 324px;
      height: 356px;
      background: #F5F9FB;
      border-radius: 24px;
      box-sizing: border-box;
      text-align: center;
      img {
        width: 92px;
        height: 92px;
        margin: 40px auto 0;
      }
      h3 {
        margin: 36px 0 12px;
        font-weight: bold;
        font-size: 32px;
        color: #092A52;
        line-height: 48px;
        text-align: center;
      }
      p {
        font-weight: 400;
        font-size: 26px;
        color: #092A52;
        line-height: 44px;
        text-align: center;
      }
    }
  }
}
</style>
